
export default {
    template: /*html*/`
    <div>
        <h4>Done!</h4>
        <p>
            You can now start your server in the <router-link to="/services/engine">engine</router-link> page
        </p>
    </div>
    `
};